import SelectField from '../../../../core/components/Fields/SelectField.tsx';
import type { TargetFieldOption } from '../types.ts';

interface TargetFieldSelectProps {
    options: TargetFieldOption[];
    value: string;
    onChange: (target: string) => void;
    placeholder: string;
    modal?: boolean;
}

const TargetFieldSelect = ({ options, value, onChange, placeholder, modal }: TargetFieldSelectProps) => (
    <SelectField
        value={value || null}
        onValueChange={(target) => onChange(target ?? '')}
        options={[
            ...(value && !options.some((option) => option.target === value) ? [{ value, label: value }] : []),
            ...options.map((option) => ({
                value: option.target,
                label: option.target,
                description: option.description,
            })),
        ]}
        placeholder={placeholder}
        modal={modal}
    />
);

export default TargetFieldSelect;
